<template>
  <div class="chooseproduct">
    <div class="title">
        请选择对方存在该问题的商品
    </div>
    <div class="wrap" v-show="selectProduct.length > 0">
      <ProductItem
        v-for="(item,index) in selectProduct"
        :key="index"
        :item="item">
      </ProductItem>
      <z-button @click="changeProduct" type="link">修改商品</z-button>
    </div>
    <z-button class="uploadbtn" icon="plus" v-show="selectProduct.length == 0" @click="changeProduct">选择商品内容</z-button>
    <ProductList @select="ProductSelect" :show="showProduct" @close="closeProduct"></ProductList>
  </div>
</template>

<script>
import ProductList from '../ProductList'
import ProductItem from '../ProductList/ProductItem'
import { Button } from '@zz-common/zz-ui'
export default {
  name: 'ChooseProduct',
  components: {
    ProductList,
    ProductItem,
    zButton: Button
  },
  data() {
    return {
      submitData: {},
      selectProduct: [],
      showProduct: false
    }
  },
  props: {
    Finished: {
      type: Function,
      default: () => {}
    } //向外传递数据
  },
  methods: {
    changeProduct() {
      this.showProduct = true
    },
    ProductSelect(data) {
      this.selectProduct = data
      this.Finished(data)
    },
    closeProduct() {
      this.showProduct = false
    }
  }
}
</script>
<style lang="less" scoped>
@import "index.less";
</style>